import { breakpoints } from '@costar-ui/cosmos';
import useMedia from './use-media.esm.js';

var useTrueAtMediaBreakpointLessThen = function useTrueAtMediaBreakpointLessThen(screenWidth) {
  var mediaBreakpoint = "screen and (max-width: ".concat(breakpoints[screenWidth], "px)");
  return useMedia([mediaBreakpoint], [true], false);
};
var useTrueAtMediaBreakpointLessThen$1 = useTrueAtMediaBreakpointLessThen;

export { useTrueAtMediaBreakpointLessThen$1 as default };
//# sourceMappingURL=use-true-at-media-breakpoint-less-then.esm.js.map
